import type {AxiosPromise} from 'axios'
import axios, {CancelToken} from '@/plugin/axios'
import api from '@/api'
import qs from 'qs'
const cancelFn: Record<string, (reason?: string) => void> = {}
const cancelFnWarranty: Record<string, (reason?: string) => void> = {}

export const service = {
  sendNewGuideForm,
  fetchFieldMods,
  getWarrantyPlans,
  getBuiltOptions
}

function sendNewGuideForm(_postParameters: Record<string, any>): AxiosPromise {
  return axios.post(api.endpoints.DPMM_API.TROUBLESHOOTING_GUIDE, _postParameters)
}

function promiseWrapper<T = any>(_promise: Promise<any>): Promise<T> {
  return new Promise((resolve, reject) => {
    _promise.then(({data}) => {
      resolve(data.items)
    }).catch(e => {
      if (e.code === 404 && e.message === 'Not Found') resolve([] as any)
      if (e.code === 404 && e.message === 'No field modifications found.') resolve([] as any)
      if (e.code === 404 && e.message === 'No warranty plans found.') resolve([] as any)
      else reject(e)
    })
  })
}

function fetchFieldMods(sn: string, campaignCode: string): Promise<any> {
  if (typeof cancelFn['fieldmods'] === 'function') cancelFn['fieldmods']('isCancelled')
  return promiseWrapper(axios.get(api.endpoints.DPMM_API.SERVICE_FIELD_MODIFICATIONS.replace('{serial}', sn), {
    params: {campaign_code: campaignCode},
    cancelToken: new CancelToken(function executor(c) { cancelFn['fieldmods'] = c })
  }))
}

function getWarrantyPlans(sn: string, _params: Record<string, any> = {}): Promise<any> {
  if (typeof cancelFnWarranty[_params.warranty_status] === 'function') cancelFnWarranty[_params.warranty_status]('isCancelled')
  return promiseWrapper(axios.get(api.endpoints.DPMM_API.WARRANTY_PLANS.replace('{serial}', sn), {
    params: _params,
    paramsSerializer: (params: Record<string, any>) => qs.stringify(params, {arrayFormat: 'repeat'}),
    cancelToken: new CancelToken(function executor(c) { cancelFnWarranty[_params.warranty_status] = c })
  }))
}

function getBuiltOptions(sn: string): AxiosPromise {
  if (typeof cancelFn['options'] === 'function') cancelFn['options']('isCancelled')
  return axios.get(api.endpoints.DPMM_API.OPTIONS_LIST.replace('{serial}', sn), {
    cancelToken: new CancelToken(function executor(c) { cancelFn['options'] = c })
  })
}
